/* Text-only presentation for the existing PDP Style selects. Symmetry owns
   listbox interaction; the builder's unchanged native select owns order state. */
(function () {
  'use strict';
  if (window.PTStyleDropdown || !customElements.get('custom-select')) return;
  var BaseSelect = customElements.get('custom-select');

  function content(option) {
    var row = document.createElement('span');
    row.className = 'pt-style-dropdown__value pointer-events-none';
    var label = document.createElement('span');
    label.className = 'pt-style-dropdown__name';
    label.textContent = option.text;
    row.appendChild(label);
    return row;
  }

  class StyleSelect extends BaseSelect {
    constructor() {
      super();
      this.nativeSelect = this.querySelector('select');
      this.button.disabled = this.nativeSelect.disabled;
      this.button.setAttribute('aria-controls', this.listbox.id);
      this.listbox.setAttribute('aria-labelledby', this.button.id);
      this.nativeSelect.hidden = true;
      this.nativeSelect.tabIndex = -1;
      var label = this.parentElement.querySelector('[data-pt-field-label="style"]');
      if (label) {
        label.htmlFor = this.button.id;
        label.id = this.id + '-label';
        this.button.setAttribute('aria-labelledby', label.id + ' ' + this.id + '-value');
        this.listbox.setAttribute('aria-labelledby', label.id);
      }
      this.nativeSelect.addEventListener('change', () => this.syncButton());
      this.syncButton();
    }

    syncButton() {
      var selected = this.nativeSelect.options[this.nativeSelect.selectedIndex];
      if (!selected) return;
      var row = content(selected);
      row.id = this.id + '-value';
      this.button.firstElementChild.replaceWith(row);
      this.options.forEach((item) => {
        var current = item.dataset.value === selected.value;
        item.setAttribute('aria-selected', String(current));
        if (current) this.selectedOption = item;
      });
    }

    showListbox() {
      // Native mousedown is prevented below, so focus can move immediately.
      // Avoid a delayed open resetting keyboard focus after rapid input.
      this.listbox.hidden = false;
      {
        const button = this.button.getBoundingClientRect();
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const top = viewport ? viewport.offsetTop : 0;
        const below = bottom - button.bottom - 12;
        const above = button.top - top - 12;
        const upward = below < 176 && above > below;
        this.listbox.style.top = upward ? 'auto' : 'calc(100% + 4px)';
        this.listbox.style.bottom = upward ? 'calc(100% + 4px)' : 'auto';
        this.listbox.style.maxHeight = Math.max(44, Math.min(320, upward ? above : below)) + 'px';
      }
      this.listboxOpen = true;
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      this.listbox.setAttribute('aria-hidden', 'false');
      this.focusOption(this.selectedOption);
      this.listbox.focus({ preventScroll: true });
      this.addListboxOpenListeners();
    }

    focusOption(option) {
      if (!this.isConnected) return;
      if (!option || option.hidden) {
        option = Array.from(this.options).find((item) => !item.hidden && item.getAttribute('aria-disabled') !== 'true');
      }
      if (!option) return;
      super.focusOption(option);
      this.listbox.setAttribute('aria-activedescendant', option.id);
    }

    handleKeydown(event) {
      if (!this.listboxOpen && event.key === 'Enter' && !this.button.disabled) {
        event.preventDefault();
        this.showListbox();
      } else {
        super.handleKeydown(event);
      }
    }

    handleMousedown(event) {
      if (event.button !== 0 || this.button.disabled) return;
      event.preventDefault();
      if (this.listboxOpen) this.hideListbox();
      else super.handleMousedown(event);
    }

    selectOption(option) {
      if (!option || option.getAttribute('aria-disabled') === 'true') return;
      var selectId = this.nativeSelect.id;
      super.selectOption(option);
      // Builders replace the card synchronously on change. Return keyboard
      // focus to its replacement rather than the detached button.
      var liveSelect = document.getElementById(selectId);
      var liveDropdown = liveSelect && liveSelect.closest('pt-style-select');
      if (liveDropdown) liveDropdown.button.focus({ preventScroll: true });
    }

    hideListbox() {
      this.syncButton();
      super.hideListbox();
    }
  }
  customElements.define('pt-style-select', StyleSelect);

  function enhance(select, gender) {
    if (!select.id || select.disabled || select.closest('pt-style-select') || !window.PTStyleCatalog.resolve(gender)) return;
    // Populate the inert template before insertion so the native custom-select
    // constructor receives complete markup, including the original select.
    var template = document.createElement('template');
    template.innerHTML = '<pt-style-select class="pt-style-dropdown"><div class="custom-select relative w-full"><button class="custom-select__btn input items-center" type="button" aria-expanded="false" aria-haspopup="listbox"><span></span><svg class="icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></button><ul class="custom-select__listbox absolute invisible" role="listbox" tabindex="-1" aria-hidden="true" hidden></ul></div></pt-style-select>';
    var dropdown = template.content.firstElementChild;
    dropdown.id = select.id + '-visual';
    dropdown.dataset.gender = gender;
    var button = dropdown.querySelector('button');
    var listbox = dropdown.querySelector('ul');
    button.id = dropdown.id + '-button';
    listbox.id = dropdown.id + '-options';
    Array.from(select.options).forEach(function (option, index) {
      var item = document.createElement('li');
      item.className = 'custom-select__option flex items-center js-option';
      item.id = dropdown.id + '-option-' + index;
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', String(option.selected));
      item.dataset.value = option.value;
      item.hidden = option.hidden;
      if (option.disabled) {
        item.classList.add('is-disabled');
        item.setAttribute('aria-disabled', 'true');
      }
      item.appendChild(content(option));
      listbox.appendChild(item);
      if (option.selected) listbox.setAttribute('aria-activedescendant', item.id);
    });
    var parent = select.parentElement;
    var next = select.nextSibling;
    dropdown.appendChild(select);
    parent.insertBefore(template.content, next);
  }

  window.PTStyleDropdown = { enhance: enhance };
})();
